module.exports = __webpack_public_path__ + "img/picto-previsualiser.32980866.svg";